import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UserSettingsProvider } from './context/UserSettingsContext';
import { I18nProvider } from './context/I18nContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <AuthProvider>
        <UserSettingsProvider>
          <App />
        </UserSettingsProvider>
      </AuthProvider>
    </I18nProvider>
  </React.StrictMode>
);
